import TruckService from "./TruckService";

class AdminService extends TruckService {

    getFactories(afterResponse) {
        this.requestJson('getallstations', null, afterResponse);
    }
    getTrucks(afterResponse) {
        this.requestJson('getalltrucks', null, afterResponse);
    }

    SchedulingOrders(afterResponse) {
        this.requestJson('doschedule', null, afterResponse);
    }

}
export default AdminService;

